import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
function lazyLoad(view) {
  return () => import(`@/module/joborder/pages/${view}/${view}.vue`)
}
export default [
  // { path: '/addJob', component: lazyLoad('addJob') },
  // { path: '/searchJob', component: lazyLoad('searchPage') },
  // { path: '/reviewJob', component: lazyLoad('reviewJob') },
  // { path: '/listJob', component: lazyLoad('listJob') },
  // { path: '/employerLogin', component: lazyLoad('employerLogin') },
  // { path: '/viewJobPost', component: lazyLoad('viewJobPost') },
  // { path: '/addEmployer', component: lazyLoad('addEmployer') },
  // { path: '/employSignup', component: lazyLoad('employerSignUp') },
  // { path: '/editJob', component: lazyLoad('editJob') },
  // { path: '/appliedJobList', component: lazyLoad('appliedJobsByJobseeker') },
  // { path: '/interviewScheduledJobList', component: lazyLoad('interviewScheduledJobsByJobseeker') },
  // { path: '/jobFilters', component: lazyLoad('jobFilters') },
  // { path: '/followingJobs', component: lazyLoad('followingJobs') },
  // { path: '/jobseekersForAppliedJobs', component: lazyLoad('postjobJobseekerList') },
  // { path: '/employerProfile', component: lazyLoad('employerProfile') },
  // { path: '/editEmployer', component: lazyLoad('editEmployer') },
  // { path: '/resetPasswordForEmployer/:mailtoken', component: lazyLoad('resetPasswordForEmployer') },
  // { path: '/employerDashboard', component: lazyLoad('employerDashboard') },
  // { path: '/hrUserList', component: lazyLoad('hrUserList') },
  // { path: '/registerEmployee', component: lazyLoad('addEmployee') },
  // { path: '/listEmployee', component: lazyLoad('listEmployees') },
  // { path: '/viewJobPostForSocialMedia/:id', component: lazyLoad('reviewJobWithoutApi') },
  // { path: '/applyEmployees', component: lazyLoad('listEmployeeBasedOnQuestionsCriteria') },
  // { path: '/employerChat', component: lazyLoad('employerChat') },
  // { path: '/savedJobs', component: lazyLoad('savedJobs') },
  { path: '/listAds', component: lazyLoad('listAds') },
]
